import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Box, DownloadFile, Icon, InputWithIcon, PrintFile, SelectMenu } from '@livable/saas-react-components';
import { Container, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import BreadcrumbsBar from 'src/components/general/BreadcrumbsBar';
import NoDataPlaceholder from 'src/components/shared/NoDataPlaceholder';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const UtilityBillsPage = observer(() => {
  const classes = useStyles();
  const store = useStore();
  const history = useLocation();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const address = history.state.address;
  const propertyId = new URLSearchParams(history.search).get('id');
  const breadcrumbArray = [{
    title: t('file_cabinet.files'),
    link: '/file_cabinet'
  }, {
    title: t('file_cabinet.utility_bills'),
    link: '/file_cabinet'
  }, {
    title: address
  }];
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    allocationNameSort = _useState2[0],
    setAllocationNameSort = _useState2[1];
  const _useState3 = useState([t('file_cabinet.all_months')]),
    _useState4 = _slicedToArray(_useState3, 2),
    allocationMonthFilterList = _useState4[0],
    setAllocationMonthFilterList = _useState4[1];
  const _useState5 = useState(allocationMonthFilterList[0]),
    _useState6 = _slicedToArray(_useState5, 2),
    allocationMonthFilter = _useState6[0],
    setAllocationMonthFilter = _useState6[1];
  const _useState7 = useState([moment().format('YYYY')]),
    _useState8 = _slicedToArray(_useState7, 2),
    allocationYearFilterList = _useState8[0],
    setAllocationYearFilterList = _useState8[1];
  const _useState9 = useState(allocationYearFilterList[0]),
    _useState0 = _slicedToArray(_useState9, 2),
    allocationYearFilter = _useState0[0],
    setAllocationYearFilter = _useState0[1];
  const _useState1 = useState([t('file_cabinet.all_utilities')]),
    _useState10 = _slicedToArray(_useState1, 2),
    utilityFilterList = _useState10[0],
    setUtilityFilterList = _useState10[1];
  const _useState11 = useState(utilityFilterList[0]),
    _useState12 = _slicedToArray(_useState11, 2),
    utilityFilter = _useState12[0],
    setUtilityFilter = _useState12[1];
  const _useState13 = useState([t('file_cabinet.all_members')]),
    _useState14 = _slicedToArray(_useState13, 2),
    uploadedByFilterList = _useState14[0],
    setUploadedByFilterList = _useState14[1];
  const _useState15 = useState(uploadedByFilterList[0]),
    _useState16 = _slicedToArray(_useState15, 2),
    uploadedByFilter = _useState16[0],
    setUploadedByFilter = _useState16[1];
  const _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    searchKey = _useState18[0],
    setSearchKey = _useState18[1];
  const handleSearchKeyChange = e => {
    setSearchKey(e.target.value);
  };
  const getUtilityInfo = async ids => {
    if (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
      const resp = await store.utilityProviders.getUtilityInfoAsync.run({
        utilityIds: ids
      });
      return resp;
    } else {
      const resp = await store.utilityProviders.getPropertyUtilityInfoAsync.run({
        utilityIds: ids,
        propertyId: propertyId
      });
      return resp;
    }
  };
  const _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    allocationsBillData = _useState20[0],
    setAllocationsBillData = _useState20[1];
  const fetchPropertyResidentsBills = async () => {
    const response = await store.allocations.getPropertyBillsFileCabinetAsync.run({
      propertyId
    });
    if (response !== null && response !== void 0 && response.isSuccessful) {
      const propertyAllocationBills = response.response;
      const _await$getUtilityInfo = await getUtilityInfo(Array.from(new Set(propertyAllocationBills.map(i => i.utilityId)))),
        getUtilityInfoIsSuccesful = _await$getUtilityInfo.isSuccessful,
        utilitiesInfo = _await$getUtilityInfo.response.utilities;
      if (getUtilityInfoIsSuccesful) {
        propertyAllocationBills.forEach((item, index) => {
          var _utilitiesInfo$find;
          propertyAllocationBills[index].utilityType = (_utilitiesInfo$find = utilitiesInfo.find(i => i.utilityId === item.utilityId)) === null || _utilitiesInfo$find === void 0 ? void 0 : _utilitiesInfo$find.utilityTypeName;
        });
      }
      setAllocationMonthFilterList(Array.from(new Set([allocationMonthFilterList[0], ...propertyAllocationBills.map(i => moment(i.serviceDateFrom).format('MMMM')), ...propertyAllocationBills.map(i => moment(i.serviceDateTo).format('MMMM'))])));
      setAllocationYearFilterList(Array.from(new Set([allocationYearFilterList[0], ...propertyAllocationBills.map(i => moment(i.serviceDateFrom).format('YYYY')), ...propertyAllocationBills.map(i => moment(i.serviceDateTo).format('YYYY'))])));
      setUtilityFilterList(Array.from(new Set([utilityFilterList[0], ...propertyAllocationBills.map(i => i.utilityType)])));
      setUploadedByFilterList(Array.from(new Set([uploadedByFilterList[0], ...propertyAllocationBills.map(i => i.fileUploadedBy).filter(i => !!i)])));
      setAllocationsBillData(propertyAllocationBills);
    }
  };
  const filterOptions = {
    allocationMonth: 'allocationMonth',
    allocationYear: 'allocationYear',
    uploadedBy: 'uploadedBy',
    utility: 'utility'
  };
  const handleFilterOption = (event, filterOption) => {
    switch (filterOption) {
      case filterOptions.allocationMonth:
        setAllocationMonthFilter(event.target.value);
        break;
      case filterOptions.allocationYear:
        setAllocationYearFilter(event.target.value);
        break;
      case filterOptions.utility:
        setUtilityFilter(event.target.value);
        break;
      case filterOptions.uploadedBy:
        setUploadedByFilter(event.target.value);
        break;
    }
  };
  const getFilteredData = () => {
    return allocationsBillData.filter(i => {
      const searchPhrase = new RegExp(searchKey, 'gi');
      return searchKey.length > 0 ? " ".concat(i.allocationName).search(searchPhrase) > 0 || " ".concat(i.fileUploadedBy).search(searchPhrase) > 0 || " ".concat(i.utilityType).search(searchPhrase) > 0 : true;
    }).filter(i => {
      return (allocationMonthFilter === allocationMonthFilterList[0] ? moment(allocationMonthFilter + ' ' + allocationYearFilter).isBetween(moment(i.serviceDateFrom), moment(i.serviceDateTo), 'year', []) : moment(allocationMonthFilter + ' ' + allocationYearFilter).isBetween(moment(i.serviceDateFrom), moment(i.serviceDateTo), 'month', [])) && (i.fileUploadedBy === uploadedByFilter || uploadedByFilter === uploadedByFilterList[0]) && (i.utilityType === utilityFilter || utilityFilter === utilityFilterList[0]);
    }).sort((a, b) => {
      if (allocationNameSort === 'asc') {
        return a.allocationName.localeCompare(b.allocationName);
      }
      if (allocationNameSort === 'desc') {
        return b.allocationName.localeCompare(a.allocationName);
      }
    });
  };
  useEffect(() => {
    try {
      fetchPropertyResidentsBills();
    } catch (e) {
      console.log('useEffect Error', e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadcrumbsBar, {
    breadcrumbsArray: breadcrumbArray
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.filtersWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchWrapper
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "tenants-search",
    label: t('general.search'),
    variant: "outlined",
    value: searchKey,
    onChange: handleSearchKeyChange,
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.sortByMonthWrapper
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "sort-by-month-selector",
    label: t('file_cabinet.allocation_month'),
    labelId: "sort-by-selector-label",
    onChange: e => handleFilterOption(e, filterOptions.allocationMonth),
    value: allocationMonthFilter,
    className: classes.filterSelector
  }, allocationMonthFilterList.map(month => {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: uuid(),
      value: month
    }, month);
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.sortByYearWrapper
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "sort-by-year-selector",
    label: t('file_cabinet.allocation_year'),
    labelId: "sort-by-selector-label",
    onChange: e => handleFilterOption(e, filterOptions.allocationYear),
    value: allocationYearFilter,
    className: classes.filterSelector
  }, allocationYearFilterList.map(year => {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: uuid(),
      value: year
    }, year);
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.sortByUtilityWrapper
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "sort-by-utility-selector",
    label: t('file_cabinet.utilities'),
    labelId: "sort-by-selector-label",
    onChange: e => handleFilterOption(e, filterOptions.utility),
    value: utilityFilter,
    className: classes.filterSelector
  }, utilityFilterList.map(utility => {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: uuid(),
      value: utility
    }, utility);
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.sortByUploadWrapper
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "sort-by-upload-selector",
    label: t('file_cabinet.uploaded_by'),
    labelId: "sort-by-selector-label",
    onChange: e => handleFilterOption(e, filterOptions.uploadedBy),
    value: uploadedByFilter,
    className: classes.filterSelector
  }, uploadedByFilterList.map(uploadedBy => {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: uuid(),
      value: uploadedBy
    }, uploadedBy);
  })))), !!allocationsBillData.length && !!getFilteredData().length && /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "addendums files table",
    type: "fullWidth"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.clickableCell,
    onClick: () => {
      if (allocationNameSort === '') {
        setAllocationNameSort('asc');
      } else if (allocationNameSort === 'asc') {
        setAllocationNameSort('desc');
      } else {
        setAllocationNameSort('');
      }
    }
  }, "".concat(t('file_cabinet.allocation'), " ").concat(allocationNameSort === 'asc' ? '↓' : allocationNameSort === 'desc' ? '↑' : '↑↓')), /*#__PURE__*/React.createElement(TableCell, null, t('file_cabinet.service_date_range')), /*#__PURE__*/React.createElement(TableCell, null, t('file_cabinet.utility')), /*#__PURE__*/React.createElement(TableCell, null, t('file_cabinet.uploaded_by')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('file_cabinet.bill_file')))), /*#__PURE__*/React.createElement(TableBody, null, getFilteredData().map(allocation => {
    var _store$fileCabinet$ge, _store$files$getPresi, _store$fileCabinet$ge2;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: allocation.fileId
    }, /*#__PURE__*/React.createElement(TableCell, null, allocation.allocationName), /*#__PURE__*/React.createElement(TableCell, null, "".concat(moment(allocation.serviceDateFrom).format('MM/DD/YYYY'), " - ").concat(allocation.serviceDateTo ? moment(allocation.serviceDateTo).format('MM/DD/YYYY') : t('file_cabinet.current'))), /*#__PURE__*/React.createElement(TableCell, null, allocation.utilityType || allocation.utilityId), /*#__PURE__*/React.createElement(TableCell, null, allocation.fileUploadedBy || 'N/A'), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(PrintFile, {
      disabled: ((_store$fileCabinet$ge = store.fileCabinet.getPropertyBillsFileCabinetAsync) === null || _store$fileCabinet$ge === void 0 ? void 0 : _store$fileCabinet$ge.inProgress) || ((_store$files$getPresi = store.files.getPresignedFileDownloadUrlAsync) === null || _store$files$getPresi === void 0 ? void 0 : _store$files$getPresi.inProgress) || allocation.fileId === null,
      fileId: allocation.fileId,
      getUrlAsyncCallback: async () => {
        const resp = await store.files.getPresignedFileDownloadUrlAsync.run({
          fileId: allocation.fileId,
          isPreview: true
        });
        if (resp !== null && resp !== void 0 && resp.isSuccessful) {
          return resp.response;
        }
      },
      href: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled ? null : "".concat(store.files.getFilePreviewLink({
        fileId: allocation.fileId
      }))
    }), /*#__PURE__*/React.createElement(DownloadFile, {
      disabled: ((_store$fileCabinet$ge2 = store.fileCabinet.getPropertyBillsFileCabinetAsync) === null || _store$fileCabinet$ge2 === void 0 ? void 0 : _store$fileCabinet$ge2.inProgress) || allocation.fileId === null,
      fileId: allocation.fileId,
      usePreSignedDownload: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled,
      store: store
    })));
  })))), !!allocationsBillData.length && !getFilteredData().length && /*#__PURE__*/React.createElement(NoDataPlaceholder, {
    text: t('file_cabinet.no_data_found')
  }), !allocationsBillData.length && /*#__PURE__*/React.createElement(NoDataPlaceholder, {
    text: t('file_cabinet.no_data_available')
  })))));
});